import React from 'react';
import { createPortal } from 'react-dom';
import { useModalGastoCompra } from './Hooks/useModalGastoCompra';

import SeccionComprobanteProveedor from '../ComponentesGasto/SeccionComprobanteProveedor';
import SeccionCalculoImportes from '../ComponentesGasto/SeccionCalculoImportes';
import SeccionTesoreria from '../ComponentesGasto/SeccionTesoreria';

const ModalGastoCompra = ({ show, onClose, onSuccess, initialData = null, maestros: maestrosProp = {} }) => {
    const hookData = useModalGastoCompra({ show, onClose, onSuccess, initialData, maestrosProp });

    if (!show) return null;

    const {
        formData, setFormData, loading, error, esImpuesto, esPrestamo, esModoDirecto,
        calculos, proveedores, cuentas, areas, conceptosGastos, subconceptosDisponibles,
        handleBlurCurrency, formatBlurInputAmount, handleProveedorChange, handleAreaChange,
        handleConceptoChange, handleSubmit
    } = hookData;

    return createPortal(
        <div className="fixed inset-0 bg-gray-900 bg-opacity-60 z-[1100] flex items-center justify-center p-4 backdrop-blur-sm transition-opacity text-left font-sans">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl h-auto max-h-[95vh] flex flex-col overflow-hidden border border-gray-100 animate-fade-in transition-all duration-300">
                
                {/* HEADER */}
                <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 bg-blue-50/50 shrink-0">
                    <div className="flex items-center gap-3">
                        <span className="bg-blue-100 text-blue-600 p-2.5 rounded-xl shrink-0">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </span>
                        <div>
                            <h3 className="text-lg font-bold text-gray-800 leading-none">
                                {initialData ? 'Gestionar Comprobante / Egreso' : 'Nuevo Gasto / Compra / Impuesto / Préstamo'}
                            </h3>
                            <p className="text-[10px] text-blue-800/80 font-black mt-1.5 tracking-wider uppercase select-none">
                                {esImpuesto 
                                    ? '🏛️ Registro de Tasas / AFIP / IIBB / ARCA' 
                                    : esPrestamo 
                                        ? '🏦 Gestión de Préstamos y Repagos' 
                                        : 'Reg. Operativo • Egresos / Servicios'}
                            </p>
                        </div>
                    </div>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-slate-50 rounded-full cursor-pointer">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* CUERPO DEL FORMULARIO */}
                <div className="overflow-y-auto p-8 flex-grow bg-white scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent">
                    <form id="gastoForm" onSubmit={handleSubmit} className="space-y-8">
                        {error && <div className="p-4 rounded-xl bg-rose-50 border border-rose-200 text-rose-700 text-xs font-bold">⚠️ {error}</div>}

                        <SeccionComprobanteProveedor
                            formData={formData}
                            setFormData={setFormData}
                            proveedores={proveedores}
                            areas={areas}
                            conceptosGastos={conceptosGastos}
                            subconceptosDisponibles={subconceptosDisponibles}
                            handleProveedorChange={handleProveedorChange}
                            handleAreaChange={handleAreaChange}
                            handleConceptoChange={handleConceptoChange}
                        />

                        <SeccionCalculoImportes
                            formData={formData}
                            setFormData={setFormData}
                            calculos={calculos}
                            esImpuesto={esImpuesto}
                            handleBlurCurrency={handleBlurCurrency}
                            formatBlurInputAmount={formatBlurInputAmount}
                        />

                        <SeccionTesoreria hookData={hookData} />
                    </form>
                </div>

                {/* BOTONERA INFERIOR */}
                <div className="px-6 py-4 border-t border-gray-100 flex justify-end gap-3 bg-gray-50 shrink-0">
                    <button type="button" onClick={onClose} className="px-6 py-2.5 rounded-full border border-slate-300 bg-white text-slate-700 font-bold uppercase text-xs hover:bg-slate-50 shadow-sm transition-all transform active:scale-95 select-none cursor-pointer">Cancelar</button>
                    <button type="submit" form="gastoForm" disabled={loading} className="px-8 py-2.5 rounded-full text-white font-bold transition-all uppercase text-xs transform active:scale-95 min-w-[180px] shadow-lg select-none bg-blue-600 hover:bg-blue-700 shadow-blue-100 cursor-pointer">
                        {loading ? 'Guardando...' : 'Confirmar cambios'}
                    </button>
                </div>

            </div>
        </div>,
        document.body
    );
};

export default React.memo(ModalGastoCompra);